export enum CategoriasCuotasEnum { GENEROS, RANGOSEDAD, PAISES, ETIQUETAS }
